import { memo } from 'react';
import { useParams } from 'react-router-dom';

import { useS3Bucket } from 'hooks/s3';
import PropTypes from 'prop-types';

import {
  convertFolderPathToPrefix,
  generatePromoMaterials,
} from 'utils/generateMaterials';

import DownloadMaterials from 'components/DownloadMaterials/DownloadMaterials';

import { materialsStructure } from 'components/config/promotions';

const DownloadMaterialsPhase = ({
  downloadFileName,
  folderPath,
  trackEvent,
}) => {
  const { provider } = useParams();

  const { fetchData: fetchMaterials, loading: materialsLoading } = useS3Bucket({
    prefixes: `Promotions/${convertFolderPathToPrefix(folderPath)}/materials/`,
    formatItems: generatePromoMaterials,
  });

  return (
    <div>
      <DownloadMaterials
        variant="Base"
        type="Promo"
        provider={provider}
        structure={materialsStructure}
        downloadFileName={downloadFileName}
        folderPath={folderPath}
        fetchMaterials={fetchMaterials}
        loading={materialsLoading}
        trackEvent={trackEvent}
      >
        Download materials
      </DownloadMaterials>
    </div>
  );
};

DownloadMaterialsPhase.propTypes = {
  downloadFileName: PropTypes.string.isRequired,
  folderPath: PropTypes.string.isRequired,
  trackEvent: PropTypes.exact({
    name: PropTypes.string,
    props: PropTypes.object,
  }),
};

export default memo(DownloadMaterialsPhase);
